<template>
<div>
  <div class="row">
    <div class="col">
      <form v-on:submit.prevent="save">

        <div class="form-group" v-if="token.cadastra">
          <label for="cooperado">Empreendimento / Unidade</label>
          <vue-bootstrap-typeahead
            v-model="form.cooperado"
            :data="cooperados"
            :serializer="getNameLogin"
            @hit="hit"
            @input="onInput"
            :disabled="form.usuario"
          />
          <p v-if="form.usuario">{{form.nome}} selecionado <a href="javascript:;" @click="form.usuario = ''; form.nome = ''">Desmarcar</a></p>
          <small class="text-danger" v-if="!form.usuario">* Selecione um usuário/unidade previamente cadastrado, caso não esteja listando cadastre o mesmo no modulo de usuários.</small>
        </div>


        <div class="form-group">
          <label for="atividade">Atividade</label>
          <atividades v-model="form.atividade" />
        </div>

        <div class="form-group">
          <label for="documento">Documento</label>
          <input
            type="text"
            class="form-control"
            v-model="form.documento"
            id="documento"
            placeholder="Número do documento"
            rows="3"
            :disabled="acao === 'edit'"
          />
        </div>

        <div class="form-group" v-show="form.licenca">
          <label for="tipo">Tipo</label>
          <select :disabled="acao === 'edit'" v-model="form.tipoLicenca" class="form-control" name="tipo" id="tipo" style="text-transform: uppercase;">
            <option value=""></option>
            <option value="AA">AA</option>
            <option value="AA de Melhoria">AA de Melhoria</option>
            <option value="ADAPAR">ADAPAR</option>
            <option value="ADITIVO">ADITIVO</option>
            <option value="ALVARÁ">ALVARÁ</option>
            <option value="ALVARÁ LOCALIZAÇÃO">ALVARÁ LOCALIZAÇÃO</option>
            <option value="ALVARÁ SANITÁRIO">ALVARÁ SANITÁRIO</option>
            <option value="AUTORIZAÇÃO TRANSPORTE IBAMA">AUTORIZAÇÃO TRANSPORTE IBAMA</option>
            <option value="ANP CAOPA">ANP CAOPA</option>
            <option value="ANUÊNCIA PRÉVIA A DESMEMBRAMENTO - COM REMEMBRAMENTO">ANUÊNCIA PRÉVIA A DESMEMBRAMENTO - COM REMEMBRAMENTO</option>
            <option value="ANUÊNCIA PRÉVIA A DESMEMBRAMENTO">ANUÊNCIA PRÉVIA A DESMEMBRAMENTO</option>
            <option value="ANUÊNCIA PRÉVIA A LOTEAMENTO, CONDOMÍNIO OU CONJUNTO HABITACIONAL">ANUÊNCIA PRÉVIA A LOTEAMENTO, CONDOMÍNIO OU CONJUNTO HABITACIONAL</option>
            <option value="APROVAÇÃO DE LOTEAMENTO">APROVAÇÃO DE LOTEAMENTO</option>
            <option value="APROVAÇÃO DE PROJETO">APROVAÇÃO DE PROJETO</option>
            <option value="AR - ATESTADO DE REGULARIDADE">AR - ATESTADO DE REGULARIDADE</option>
            <option value="ATUALIZAÇÃO QUADRO ABNT">ATUALIZAÇÃO QUADRO ABNT</option>
            <option value="AUTORIZAÇÃO DE TERRAPLANAGEM">AUTORIZAÇÃO DE TERRAPLANAGEM</option>
            <option value="AVCB - AUTO DE VISTORIA DO CORPO DE BOMBEIROS">AVCB - AUTO DE VISTORIA DO CORPO DE BOMBEIROS</option>
            <option value="CADRI">CADRI</option>
            <option value="CARTA DE ANUÊNCIA">CARTA DE ANUÊNCIA</option>
            <option value="CARTA DE VIABILIDADE - ÁGUA">CARTA DE VIABILIDADE - ÁGUA</option>
            <option value="CARTA DE VIABILIDADE - ENERGIA">CARTA DE VIABILIDADE - ENERGIA</option>
            <option value="CARTA DE VIABILIDADE - ESGOTO">CARTA DE VIABILIDADE - ESGOTO</option>
            <option value="CERTIDÃO DE ART">CERTIDÃO DE ART</option>
            <option value="CERTIDÃO DE DIRETRIZES E PARÂMETROS URBANÍSTICOS">CERTIDÃO DE DIRETRIZES E PARÂMETROS URBANÍSTICOS</option>
            <option value="CERTIDÃO DE IMÓVEL URBANO E INEXISTÊNCIA DE RESERVA LEGAL E ÁREA DE APP">CERTIDÃO DE IMÓVEL URBANO E INEXISTÊNCIA DE RESERVA LEGAL E ÁREA DE APP</option>
            <option value="CERTIDÃO NEGATIVA DE DESAPROPRIAÇÃO">CERTIDÃO NEGATIVA DE DESAPROPRIAÇÃO</option>
            <option value="CERTIDÃO NEGATIVA DE TOMBAMENTO">CERTIDÃO NEGATIVA DE TOMBAMENTO</option>
            <option value="CERTIFICADO CORPO BOMBEIROS (CVCB)">CERTIFICADO CORPO BOMBEIROS (CVCB)</option>
            <option value="CERTIFICADO DE DESTINAÇÃO RESÍDUOS">CERTIFICADO DE DESTINAÇÃO RESÍDUOS</option>
            <option value="Certificação ISO">Certificação ISO</option>
            <option value="CN DE DESAPROPRIAÇÃO, TOMBAMENTO E PREEMPÇÃO">CN DE DESAPROPRIAÇÃO, TOMBAMENTO E PREEMPÇÃO</option>
            <option value="CONSULTA PRÉVIA">CONSULTA PRÉVIA</option>
            <option value="CONTRATO">CONTRATO</option>
            <option value="CREA">CREA</option>
            <option value="CRL">CRL</option>
            <option value="CTF IBAMA">CTF IBAMA</option>
            <option value="DAI">DAI</option>
            <option value="DAIL">DAIL</option>
            <option value="DECLARAÇÃO DE RENOVAÇÃO DO ALVARÁ SANITÁRIO">DECLARAÇÃO DE RENOVAÇÃO DO ALVARÁ SANITÁRIO</option>
            <option value="DECLARAÇÃO DE VIABILIDADE URBANA">DECLARAÇÃO DE VIABILIDADE URBANA</option>
            <option value="DECLARACAODEDISPENSA">DECLARAÇÃO DE DISPENSA</option>
            <option value="DIREITO DE PREEMPÇÃO">DIREITO DE PREEMPÇÃO</option>
            <option value="DISTRATO">DISTRATO</option>
            <option value="DLAE">DLAE</option>
            <option value="HABITE-SE">HABITE-SE</option>
            <option value="INTERFERÊNCIA DE PLANOS E PROJETOS">INTERFERÊNCIA DE PLANOS E PROJETOS</option>
            <option value="ISO">ISO</option>
            <option value="LAS">LAS</option>
            <option value="LASR">LASR</option>
            <option value="LC - LICENÇA DE CONSTRUÇÃO">LC - LICENÇA DE CONSTRUÇÃO</option>
            <option value="LI - LICENÇA DE INSTALAÇÃO">LI - LICENÇA DE INSTALAÇÃO</option>
            <option value="LI-A">LI-A</option>
            <option value="LI">LI</option>
            <option value="LO - LICENÇA DE OPERAÇÃ">LO - LICENÇA DE OPERAÇÃO</option>
            <option value="LO - LICENÇA DE OPERAÇÃO - CPRH">LO - LICENÇA DE OPERAÇÃO - CPRH</option>
            <option value="LO-A">LO-A</option>
            <option value="LO">LO</option>
            <option value="LOR">LOR</option>
            <option value="LP - LICENÇA PRÉVIA">LP - LICENÇA PRÉVIA</option>
            <option value="LP-A">LPA</option>
            <option value="LP">LP</option>
            <option value="LPU">LPU</option>
            <option value="OUTORGA - ÁGUA SUBTERRÂNEA">OUTORGA - ÁGUA SUBTERRÂNEA</option>
            <option value="OUTORGA - ÁGUA SUPERFICIAL">OUTORGA - ÁGUA SUPERFICIAL</option>
            <option value="OUTORGA CAPTAÇÃO SUB">OUTORGA CAPTAÇÃO SUB</option>
            <option value="OUTORGA CAPTAÇÃO SUP">OUTORGA CAPTAÇÃO SUP</option>
            <option value="OUTORGA LANÇAMENTO">OUTORGA LANÇAMENTO</option>
            <option value="OUTRO">OUTRO</option>
            <option value="PARECER TÉCNICO ">PARECER TÉCNICO </option>
            <option value="PARECER TÉCNICO A PLANO URBANÍSTICO">PARECER TÉCNICO A PLANO URBANÍSTICO</option>
            <option value="PARS">PROTOCOLO ALTERAÇÃO DE RAZÃO SOCIAL</option>
            <option value="PLAN DE ACION">PLAN DE ACION</option>
            <option value="POLICIA FEDERAL">POLICIA FEDERAL</option>
            <option value="PORTARIADEOUTORGA">PORTARIA DE OUTORGA</option>
            <option value="PROJETO DE REFORMA COM OU SEM ACRÉSCIMO">PROJETO DE REFORMA COM OU SEM ACRÉSCIMO</option>
            <option value="PROJETOS ESPECIAIS">PROJETOS ESPECIAIS</option>
            <option value="PROTOCOLOAA">PROTOCOLO AA</option>
            <option value="PROTOCOLODEOUTORGA">PROTOCOLO DE OUTORGA</option>
            <option value="PROTOCOLODLAE">PROTOCOLO DLAE</option>
            <option value="PROTOCOLOLAS">PROTOCOLO LAS</option>
            <option value="PROTOCOLOLI">PROTOCOLO LI</option>
            <option value="PROTOCOLOLO-A">PROTOCOLO LO-A</option>
            <option value="PROTOCOLOLO">PROTOCOLO LO</option>
            <option value="PROTOCOLOLOR">PROTOCOLO LOR</option>
            <option value="PROTOCOLOLP-A">PROTOCOLO LP-A</option>
            <option value="PROTOCOLOLP">PROTOCOLO LP</option>
            <option value="PROTOCOLORLAS">PROTOCOLO RLAS</option>
            <option value="PROTOCOLORLI">PROTOCOLO RLI</option>
            <option value="PROTOCOLORLO">PROTOCOLO RLO</option>
            <option value="REGULARIZAÇÃO DE LOTEAMENTOS, CONDOMÍNIOS E CONJUNTOS HABITACIONAI">REGULARIZAÇÃO DE LOTEAMENTOS, CONDOMÍNIOS E CONJUNTOS HABITACIONAIS</option>
            <option value="REMEMBRAMENTO/DESMEMBRAMENTO/DEMARCAÇÃO URBANÍSTIC">REMEMBRAMENTO/DESMEMBRAMENTO/DEMARCAÇÃO URBANÍSTICO</option>
            <option value="REQUERIMENTO DE LI">REQUERIMENTO DE LI</option>
            <option value="REQUERIMENTO DE LO">REQUERIMENTO DE LO</option>
            <option value="REQUERIMENTO DE LP">REQUERIMENTO DE LP</option>
            <option value="RLAS">RLAS</option>
            <option value="RLI-A">RLI-A</option>
            <option value="RLI">RLI</option>
            <option value="RLO">RLO</option>
            <option value="SERFLOR">SERFLOR</option>
            <option value="TVO - TERMO DE VERIFICAÇÃO DE OBRA">TVO - TERMO DE VERIFICAÇÃO DE OBRA</option>
          </select>
        </div>

        <div class="form-group" v-show="form.licenca && !ehProtocolo()">
          <label for="validade">Data Validade</label>
          <input :disabled="acao === 'edit'" v-model="form.validade" id="validade" type="date" class="form-control">
        </div>

        <div class="form-group" v-show="!form.licenca">
          <label for="data">Data Pedido</label>
          <input :disabled="acao === 'edit'" v-model="form.data" id="data" type="date" class="form-control">
        </div>

        <vue-dropzone ref="doc" id="doc" :options="dropzoneOptions" v-on:vdropzone-success="updateDoc"></vue-dropzone>

        <div class="form-group mt-2">
          <button class="btn btn-primary btn-raised btn-block" :disabled="token.cadastra && !form.usuario">Salvar</button>
          <router-link :to="route" class="btn btn-danger btn-raised btn-block">Cancelar</router-link>
        </div>
      </form>
    </div>
  </div>
</div>
</template>

<script>
import ls from 'local-storage';
import moment from 'moment';
import vueDropzone from 'vue2-dropzone';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

export default {
  components: {
    vueDropzone,
    VueBootstrapTypeahead
  },
  data() {
    return {
      form: {
        usuario: '',
        documento: '',
        licenca: true,
        tipoLicenca: '',
        data: moment().format('YYYY-MM-DD'),
        validade: moment().format('YYYY-MM-DD'),
        mimetype: '',
        filename: '',
        originalname: '',
        atividade: '',
        nomeTec: '',
      },
      acao: 'new',
      dropzoneOptions: this.$http.getDropzoneConfig(
        `/compromissos/ambientais/upload`,
        'post',
        {
          maxFiles: 1,
          addRemoveLinks: true,
          capture: true,
          dictDefaultMessage: 'Clique ou arraste arquivos aqui para UPLOAD',
          dictRemoveFile: 'Remover'
        }
      ),
      cooperados: [],
      route: '/compromissos/ambientais'
    };
  },
  methods: {
    ehProtocolo() {
      if (this.form.tipoLicenca.indexOf('PROTOCOLO') > -1 || this.form.tipoLicenca === 'PARS' ) {
        return true;
      }

      return false;
    },
    save() {
      const method = this.$route.params.id ? this.$http.put : this.$http.post;
      this.form.acao = this.acao;
      method(this.route, this.form).then(response => {
        if (response.data.success) {
          this.$toasted.show('Cadastrado com sucesso!', this.$custom.success);
          this.$router.push(this.route);
        } else {
          this.$toasted.show('Ocorreu um erro!', this.$custom.error);
        }
      });
    },
    updateDoc(file, response) {
      this.form.mimetype = response.mimetype;
      this.form.filename = response.filename;
      this.form.originalname = response.originalname;
    },
    getNameLogin(input) {
      return `${input.login} - ${input.nome}`;
    },
    hit(input) {
      this.form.usuario = input._id;
      this.form.nome = input.nome;
      this.form.login = input.login;
    },
    onInput() {
      const coopTemQueSer = `${this.form.login} - ${this.form.nome}`;
      if (!this.form.usuario || this.form.cooperado !== coopTemQueSer) {
        this.form.nome = '';
        this.form.login = '';
        this.form.usuario = '';
      }
    },
  },
  async beforeMount() {
    if (this.$route.params.id) {
      this.acao = 'edit';
    }

    if (this.$route.params.acao) {
      this.acao = this.$route.params.acao;
    }

    if (this.token.cadastra) {
      const cooperados = await this.$http.post(`/residuos/coleta/cooperados`);
      this.cooperados = cooperados.data;
    }

    if (this.$route.params.id) {
      const form = await this.$http.get(`${this.route}/${this.$route.params.id}`);
      this.form = form.data;

      if (this.form.validade) {
        this.form.validade = moment(this.form.validade).format('YYYY-MM-DD');
      }

      if (this.form.data) {
        this.form.data = moment(this.form.data).format('YYYY-MM-DD');
      }

      for (let i = 0; i < this.cooperados.length; i++) {
        const c = this.cooperados[i];
        if (c._id === this.form.usuario) {
          this.form.nome = c.nome;
          this.form.login = c.login;
        }
      }
    }
  }
};
</script>
<style>
.vue-dropzone .dz-preview .dz-details {
  background-color: #0a823b;
}
</style>



// WEBPACK FOOTER //
// src/components/app/compromissos/ambientais/Form.vue